<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import BlankLayout from './common/layouts/blank-layout.vue';

export default @Component()
class App extends Vue {
  loading = false;

  created() {
  }

  render(h) {
    if (this.loading) {
      return h('div', { attrs: { id: 'app' } }, [
        h('i-spin', [
          h('i-icon', { props: { type: 'ios-loading', size: 18 }, class: 'spin-icon-load' }),
          h('div', [
            '加载中...',
          ]),
        ]),
      ]);
    }

    return h('div', { attrs: { id: 'app' } }, [
      h(BlankLayout, [
        h('router-view', { slot: 'content' }),
      ]),
    ]);
  }
}
</script>

<style scoped lang="less">
  .spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
</style>
